import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';



const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',

    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function LayoutDialog(props) {
    const classes = useStyles();


    const handleClose = () => {
        props.toggle(false);
    };
    const { children } = props;
    return (
        <div>
            <div style={{ zIndex: 500, position: 'fixed', top: 0, width: '100vw', height: '100vh', background: 'white' }}>
              
                {/*    <Dialog  open={true} style={{ zIndex: 500 }} onClose={handleClose} TransitionComponent={Transition}> */}
                <AppBar className={classes.appBar}>
                    {props.moduleConflict || null}
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                {children}

            </div>
            {/*     </Dialog> */}
        </div>
    );
}